import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  TextField,
  FormControl,
  InputAdornment,
  Autocomplete,
  Grid,
} from "@mui/material";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "@mui/material/Tooltip";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import DeleteIcon from "@mui/icons-material/Delete";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
//Componentes o funciones propias.
import { getData, getCodeArg } from "../../../../services/library";
import MapaCliEnv from "../MapaCliEnv";
import InfoText from "../../helper/InfoText";
import { UrlApi } from "../../../../services/apirest";
import { useMemo } from "react";

const style = {
  backgroundColor: "#ffffff",
  width: "100%",
};
const customTheme = (outerTheme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "--TextField-brandBorderColor": "#c4c4c4",
            "--TextField-brandBorderHoverColor": "#c4c4c4",
            "--TextField-brandBorderFocusedColor": "#666666", //aca
            "& label.Mui-focused": {
              color: "var(--TextField-brandBorderFocusedColor)",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: "var(--TextField-brandBorderColor)",
          },
          root: {
            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "var(--TextField-brandBorderHoverColor)",
            },
            [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: " #c4c4c4",
              borderWidth: "1px",
            },
          },
        },
      },
    },
  });
function AltaDomicilioEnv(props) {
  //Estados que guardarán los datos necesarios para completar los datos del formulario.
  const [provincias, setProvincias] = useState(null);
  const [localidades, setLocalidades] = useState(null);
  const [sucursales, setSucursales] = useState(null);
  const [codArg, setCodArg] = useState("");
  const [geozonasPorDomicilio, setGeozonasPorDomicilio] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Variables o estados que manejan componentes visuales
  const txtfldcolor = "primary";
  const outerTheme = useTheme();
  const bgColor = "#fff";
  const size = "small";
  const [expandedAccordion, setExpandedAccordion] = useState(0); // Estado para rastrear el Accordion expandido

  const listaDomIdsLocalidades = useMemo(
    () => props.listaDom.map((d) => d.id_localidad),
    [props.listaDom],
  );

  useEffect(() => {
    const fetchGeozonas = async () => {
      try {
        setLoading(true);

        // Filtrar domicilios con localidad válida
        const domiciliosValidos = props.listaDom.filter(
          (dom) => dom.id_localidad && dom.id_localidad !== "",
        );

        // Crear array de promesas para todas las peticiones
        const requests = domiciliosValidos.map((dom) =>
          fetch(`${UrlApi}/geozonas/xlocalidad/${dom.id_localidad}`)
            .then((res) => res.json())
            .then((data) => ({
              domicilioId: dom.nro_dir,
              nombreDireccion: dom.nombre_direccion || "Sin nombre",
              localidad: dom.id_localidad,
              geozonas: data,
            })),
        );

        // Ejecutar todas las peticiones en paralelo
        const results = await Promise.all(requests);

        // Convertir a formato más útil
        const geozonasMap = results.reduce((acc, result) => {
          acc[result.domicilioId] = {
            nombreDireccion: result.nombreDireccion,
            localidad: result.localidad,
            geozonas: result.geozonas,
          };
          return acc;
        }, {});

        setGeozonasPorDomicilio(geozonasMap);
      } catch (err) {
        console.error("Error fetching geozonas:", err);
        setError("Error al cargar las geozonas");
      } finally {
        setLoading(false);
      }
    };

    fetchGeozonas();
  }, [JSON.stringify(listaDomIdsLocalidades)]);

  //--------------------- FUNCIONES ---------------------//
  useEffect(() => {
    getData("/provincias", setProvincias);
    getData("/localidades", setLocalidades);
    getCodeArg(setCodArg);
    getData("/sucursales", setSucursales);
  }, []);

  const deshacerAlmacenar = (index) => {
    if (props.listaDom.length > 1) {
      const values = [...props.listaDom];
      values.splice(index, 1); // Elimina el elemento en el índice dado del array original
      // Actualiza el estado con el nuevo array que contiene el elemento eliminado
      props.setListaDom(values);
    } else {
      props.setListaDom([
        {
          nro_dir: props.uuid,
          direccion_entrega: "",
          nombre_direccion: "",
          id_provincia: "",
          id_localidad: "",
          id_sucursal: "",
          contacto: "",
          telefono_1: "",
          telefono_2: "",
          telefono_3: "",
          mails: "",
          latitud: "",
          longitud: "",
          usuario: localStorage.getItem("user"),
          activo: 1,
          verificada: 1,
          observaciones: "",
        },
      ]);
    }
  };

  //Funciones para manejar el acordión
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    if (isExpanded) {
      setExpandedAccordion(panel);
    } else {
      setExpandedAccordion(-1); // Colapsar el acordeón al cerrarse
    }
  };

  const handleAddAccordion = () => {
    props.almacenarDomicilios();
    setExpandedAccordion(props.listaDom.length);
  };

  useEffect(() => {
    if (props.tipoCliente === 1) {
      const listaDom = [...props.listaDom];
      listaDom[0] = {
        ...listaDom[0],
        id_producto: 1,
      };
      props.setListaDom(listaDom);
    }
  }, []);

  // VERIFICAR SI LA UBICACION DENTRO DE UNA ZONA
  function isPointInPolygon(point, polygon) {
    const x = point.lat;
    const y = point.lng;
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].lat,
        yi = polygon[i].lng;
      const xj = polygon[j].lat,
        yj = polygon[j].lng;

      const intersect =
        yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }

    return inside;
  }

  useEffect(() => {
    if (!loading && props.listaDom && geozonasPorDomicilio) {
      const cambios = props.listaDom.reduce((acc, domicilio, currentIndex) => {
        const domicilioGeozonas = geozonasPorDomicilio[domicilio.nro_dir];

        if (!domicilioGeozonas || !domicilio.latitud || !domicilio.longitud) {
          return acc;
        }

        const point = {
          lat: parseFloat(domicilio.latitud),
          lng: parseFloat(domicilio.longitud),
        };

        const zonaEncontrada = domicilioGeozonas.geozonas.find((zona) => {
          const esPoligonoValido =
            zona.type === "polygon" &&
            zona.coordinates &&
            zona.coordinates.length >= 3;

          if (!esPoligonoValido) {
            return false;
          }

          const estaEnPoligono = isPointInPolygon(point, zona.coordinates);

          return estaEnPoligono;
        });

        const nuevaZona = zonaEncontrada?.id || null;

        const zonaActual = domicilio.zona;

        // Solo sugerimos la zona si no hay ninguna seleccionada todavía
        if (!zonaActual && nuevaZona) {
          acc.push({ index: currentIndex, zona: nuevaZona });
        } else if (zonaActual && zonaActual !== nuevaZona) {
          // No se actualiza automáticamente
        } else {
          // console.log("✅ Sin cambios necesarios");
        }

        return acc;
      }, []);

      console.groupEnd();

      if (cambios.length > 0) {
        const updatedListaDom = [...props.listaDom];

        cambios.forEach(({ index, zona }) => {
          updatedListaDom[index].zona = zona;
        });

        props.setListaDom(updatedListaDom);
      }
    }
  }, [loading, geozonasPorDomicilio, props.listaDom, props.setListaDom]);

  const detectarZonaPorCoordenadas = (domicilio, index) => {
    const zonas = geozonasPorDomicilio[domicilio.nro_dir]?.geozonas;
    const lat = parseFloat(domicilio.latitud);
    const lng = parseFloat(domicilio.longitud);

    if (!zonas || isNaN(lat) || isNaN(lng)) {
      console.warn("Faltan datos para detectar la zona");
      return;
    }

    const puntoActual = { lat, lng };

    const zonaCoincidente = zonas.find(
      (zona) =>
        zona.type === "polygon" &&
        zona.coordinates?.length >= 3 &&
        isPointInPolygon(puntoActual, zona.coordinates),
    );

    if (zonaCoincidente) {
      const nuevaLista = [...props.listaDom];
      nuevaLista[index].zona = zonaCoincidente.id;
      props.setListaDom(nuevaLista);
    } else {
      console.warn("No se encontró zona para estas coordenadas.");
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {props.listaDom
        ? props.listaDom.map((domicilio, index) => (
            <>
              <div key={index}>
                <Container maxWidth="xl"  disableGutters>
                  <Accordion
                    defaultExpanded={index === 0}
                    expanded={expandedAccordion === index}
                    onChange={handleAccordionChange(index)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Grid
                        size={"grow"}
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid item xs={4}>
                          <Typography variant="body1" color="initial">
                            Direccion De Entrega {index + 1}{" "}
                          </Typography>
                        </Grid>

                        <Grid item xs={1}>
                          <IconButton
                            color="error"
                            onClick={(e) => {
                              deshacerAlmacenar(index);
                              e.stopPropagation();
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid
                        container
                        direction="row"
                        p={1}
                        borderRadius={3}
                        border={1}
                        borderColor={"#ABB2B9"}
                        backgroundColor="#ebebeb"
                      >
                        <Grid container xs={7} px={1}>
                          <Grid container 
                          spacing={1}
                          >
                            <Grid item xs={12}>
                              <TextField
                                style={{ backgroundColor: bgColor }}
                                autoFocus
                                fullWidth
                                color={txtfldcolor}
                                size={size}
                                label="Lugar Entrega"
                                value={
                                  domicilio.nombre_direccion &&
                                  domicilio.nombre_direccion.replace(
                                    /\b\w/g,
                                    (l) => l.toUpperCase(),
                                  )
                                }
                                name="nombre_direccion"
                                onChange={(e) => {
                                  props.handleInputChange(
                                    "nombre_direccion",
                                    e,
                                    index,
                                  );
                                }}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              {provincias && (
                                <Autocomplete
                                  disabled={!provincias}
                                  required
                                  disableClearable
                                  id="provincia"
                                  style={style}
                                  size={size}
                                  noOptionsText={"Provincia INEXISTENTE"}
                                  options={provincias}
                                  getOptionLabel={(provincia) =>
                                    provincia.id + "-" + provincia.provincia
                                  }
                                  value={
                                    provincias.find(
                                      (p) => p.id === domicilio.id_provincia,
                                    ) || null
                                  }
                                  onChange={(e, newValue) => {
                                    const updatedListaDom = [...props.listaDom];
                                    updatedListaDom[index].id_provincia =
                                      newValue ? newValue.id : null;
                                    updatedListaDom[index].id_localidad = null;
                                    props.setListaDom(updatedListaDom);
                                  }}
                                  renderOption={(props, option) => (
                                    <Box
                                      component="li"
                                      key={option.id}
                                      sx={{
                                        "& > img": { mr: 2, flexShrink: 0 },
                                      }}
                                      {...props}
                                    >
                                      {option.id} - {option.provincia}
                                    </Box>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Provincia"
                                      required
                                    />
                                  )}
                                />
                              )}
                            </Grid>
                            <Grid item xs={4}>
                              <Autocomplete
                                disabled={!localidades}
                                required
                                disableClearable
                                id="localidad"
                                name="id_localidad"
                                style={style}
                                size={size}
                                noOptionsText={"Localidad INEXISTENTE"}
                                options={
                                  localidades
                                    ? localidades.filter(
                                        (localidad) =>
                                          localidad.id_provincia ===
                                          domicilio.id_provincia,
                                      )
                                    : null
                                }
                                // getOptionLabel={(localidad) =>
                                //   localidad.id + "-" + localidad.localidad
                                // }
                                getOptionLabel={(localidad) =>
                                  localidad.cp + " - " + localidad.localidad  // Cambiado: muestra CP en lugar de ID
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value?.id 
                                }
                                value={
                                  localidades
                                    ? localidades.find(
                                        (l) => l.id === domicilio.id_localidad,
                                      ) || null
                                    : null
                                }
                                onChange={(e, newValue) => {
                                  props.handleInputChange(
                                    "id_localidad",
                                    newValue
                                      ? { target: { value: newValue.id } }
                                      : null,
                                    index,
                                  );
                                }}
                                renderOption={(props, option) => (
                                  <Box
                                    component="li"
                                    key={option.id}
                                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                    {...props}
                                  >
                                    {option.cp} - {option.localidad}
                                  </Box>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Localidad"
                                    required
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              {sucursales && (
                                <Autocomplete
                                  disabled={!sucursales}
                                  required
                                  disableClearable
                                  id="sucursal"
                                  style={style}
                                  size={size}
                                  noOptionsText={"Sucursal INEXISTENTE"}
                                  options={sucursales}
                                  getOptionLabel={(sucursal) =>
                                    sucursal.id + "-" + sucursal.nombre
                                  }
                                  value={
                                    sucursales.find(
                                      (p) => p.id === domicilio.id_sucursal,
                                    ) || null
                                  }
                                  onChange={(e, newValue) => {
                                    const updatedListaDom = [...props.listaDom];
                                    updatedListaDom[index].id_sucursal =
                                      newValue ? newValue.id : null;
                                    props.setListaDom(updatedListaDom);
                                  }}
                                  renderOption={(props, option) => (
                                    <Box
                                      component="li"
                                      key={option.id}
                                      sx={{
                                        "& > img": { mr: 2, flexShrink: 0 },
                                      }}
                                      {...props}
                                    >
                                      {option.id} - {option.nombre}
                                    </Box>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Sucursal"
                                      required
                                    />
                                  )}
                                />
                              )}
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                style={{ backgroundColor: bgColor }}
                                fullWidth
                                color={txtfldcolor}
                                size={size}
                                label="Contacto"
                                value={domicilio.contacto}
                                name="contacto"
                                onChange={(e) => {
                                  props.handleInputChange("contacto", e, index);
                                }}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                style={{ backgroundColor: bgColor }}
                                fullWidth
                                color={txtfldcolor}
                                size={size}
                                label="Mail"
                                value={domicilio.mails}
                                name="mails"
                                onChange={(e) => {
                                  props.handleInputChange("mails", e, index);
                                }}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <FormControl>
                                <TextField
                                  style={{ backgroundColor: bgColor }}
                                  fullWidth
                                  color={txtfldcolor}
                                  size={size}
                                  label="Teléfono 1"
                                  value={domicilio.telefono_1}
                                  name="telefono_1"
                                  onChange={(e) => {
                                    props.handleInputChange(
                                      "telefono_1",
                                      e,
                                      index,
                                    );
                                  }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        {codArg}
                                      </InputAdornment>
                                    ),
                                  }}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  inputProps={{
                                    maxLength: 10,
                                  }}
                                />
                                {/* <InfoText /> */}
                              </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                              <FormControl>
                                <TextField
                                  style={{ backgroundColor: bgColor }}
                                  fullWidth
                                  color={txtfldcolor}
                                  size={size}
                                  label="Teléfono 2"
                                  value={domicilio.telefono_2}
                                  name="telefono_2"
                                  onChange={(e) => {
                                    props.handleInputChange(
                                      "telefono_2",
                                      e,
                                      index,
                                    );
                                  }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        {codArg}
                                      </InputAdornment>
                                    ),
                                  }}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  inputProps={{
                                    maxLength: 10,
                                  }}
                                />
                                {/* <InfoText /> */}
                              </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                              <FormControl>
                                <TextField
                                  style={{ backgroundColor: bgColor }}
                                  fullWidth
                                  color={txtfldcolor}
                                  size={size}
                                  label="Teléfono 3"
                                  value={domicilio.telefono_3}
                                  name="telefono_3"
                                  onChange={(e) => {
                                    props.handleInputChange(
                                      "telefono_3",
                                      e,
                                      index,
                                    );
                                  }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        {codArg}
                                      </InputAdornment>
                                    ),
                                  }}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  inputProps={{
                                    maxLength: 10,
                                  }}
                                />
                                {/* <InfoText /> */}
                              </FormControl>
                            </Grid>
                            <ThemeProvider theme={customTheme(outerTheme)}>
                              <Grid item xs={3}>
                                <TextField
                                  style={{ backgroundColor: bgColor }}
                                  variant="outlined"
                                  disableTabFocus
                                  inputProps={{
                                    maxLength: 300,
                                    readOnly: true,
                                  }}
                                  color={"grey"}
                                  fullWidth
                                  size={size}
                                  label="Latitud"
                                  value={domicilio.latitud}
                                  name="latitud"
                                  onChange={(e) => {
                                    props.handleInputChange(
                                      "latitud",
                                      e,
                                      index,
                                    );
                                  }}
                                />
                              </Grid>
                              <Grid item xs={3}>
                                <TextField
                                  style={{ backgroundColor: bgColor }}
                                  fullWidth
                                  color={txtfldcolor}
                                  size={size}
                                  label="Longitud"
                                  value={domicilio.longitud}
                                  name="longitud"
                                  onChange={(e) => {
                                    props.handleInputChange(
                                      "longitud",
                                      e,
                                      index,
                                    );
                                  }}
                                  inputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Grid>

                              <Grid item xs={6}>
                                <TextField
                                  style={{ backgroundColor: bgColor }}
                                  variant="outlined"
                                  disableTabFocus
                                  inputProps={{
                                    maxLength: 200,
                                  }}
                                  color={"grey"}
                                  fullWidth
                                  size={size}
                                  label="Observaciones"
                                  value={domicilio.observaciones}
                                  name="observaciones"
                                  onChange={(e) => {
                                    props.handleInputChange(
                                      "observaciones",
                                      e,
                                      index,
                                    );
                                  }}
                                />
                              </Grid>
                              <Grid item xs={11}>
                                {geozonasPorDomicilio && (
                                  <Autocomplete
                                    disabled={!geozonasPorDomicilio}
                                    // required
                                    disableClearable
                                    id="zona"
                                    style={style}
                                    size={size}
                                    noOptionsText={"Zona INEXISTENTE"}
                                    options={
                                      geozonasPorDomicilio[domicilio.nro_dir]
                                        ?.geozonas || []
                                    }
                                    getOptionLabel={(zona) => {
                                      return zona
                                        ? `${zona.nombre} - ${
                                            zona.descripcion ||
                                            "Sin descripción"
                                          }`
                                        : "Zona no disponible";
                                    }}
                                    value={
                                      (
                                        geozonasPorDomicilio[domicilio.nro_dir]
                                          ?.geozonas || []
                                      ).find(
                                        (zona) => zona.id === domicilio.zona,
                                      ) || null
                                    }
                                    onChange={(e, newValue) => {
                                      props.handleInputChange(
                                        "zona",
                                        newValue
                                          ? { target: { value: newValue.id } }
                                          : null,
                                        index,
                                      );
                                    }}
                                    renderInput={(params) => {
                                      const hasCoords =
                                        domicilio.latitud && domicilio.longitud;

                                      const currentZone = geozonasPorDomicilio[
                                        domicilio.nro_dir
                                      ]?.geozonas?.find(
                                        (z) => z.id === domicilio.zona,
                                      );

                                      const isValidZone =
                                        hasCoords &&
                                        currentZone &&
                                        isPointInPolygon(
                                          {
                                            lat: parseFloat(domicilio.latitud),
                                            lng: parseFloat(domicilio.longitud),
                                          },
                                          currentZone.coordinates,
                                        );

                                      return (
                                        <TextField
                                          {...params}
                                          label="Zona"
                                          size="small"
                                          focused
                                          // required
                                          helperText={
                                            !hasCoords
                                              ? "Ingrese coordenadas para verificar zona"
                                              : isValidZone
                                                ? "Zona válida para estas coordenadas"
                                                : currentZone
                                                  ? "⚠️ Zona no coincide con coordenadas"
                                                  : "Seleccione una zona manualmente"
                                          }
                                          error={
                                            hasCoords &&
                                            currentZone &&
                                            !isValidZone
                                          }
                                        />
                                      );
                                    }}
                                  />
                                )}
                              </Grid>
                              <Grid item xs={1}>
                                <FormControl fullWidth>
                                  <Tooltip
                                    placement="bottom"
                                    title="Asignar Zona Automaticamente"
                                  >
                                    <IconButton
                                      aria-label="Detectar zona automáticamente"
                                      onClick={() =>
                                        detectarZonaPorCoordenadas(
                                          domicilio,
                                          index,
                                        )
                                      }
                                      size="small"
                                      color="primary"
                                    >
                                      <GpsFixedIcon />
                                    </IconButton>
                                  </Tooltip>
                                </FormControl>
                              </Grid>
                            </ThemeProvider>
                          </Grid>
                        </Grid>

                        <Grid item xs={5} style={{ height: "90px" }}>
                          <MapaCliEnv
                            datosDir={domicilio}
                            handleInputChange={props.handleInputChange}
                            index={index}
                            actualizarCoordenadas={props.actualizarCoordenadas}
                          />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Container>
              </div>
            </>
          ))
        : null}
      <Box
        sx={{
          position: "fixed",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          mb: 3,
        }}
      >
        <Tooltip title="Añadir Domicilio">
          <Fab
            color="primary"
            aria-label="add"
            onClick={handleAddAccordion}
            disabled={props.listaDom.length === 10}
            sx={{ ml: 1 }}
          >
            <AddIcon />
          </Fab>
        </Tooltip>
      </Box>
      <br />
      <br />
    </div>
  );
}

export default AltaDomicilioEnv;
